import React from "react";
import { FaEye, FaEyeSlash, FaLayerGroup, FaStar } from "react-icons/fa";

export default function SectionAdminStats({ stats }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <MiniStat
        icon={<FaLayerGroup />}
        label="Associations"
        value={stats.total}
        helper="Total enregistré"
        accent="indigo"
      />

      <MiniStat
        icon={<FaEye />}
        label="Actives"
        value={stats.active}
        helper="Visibles côté public"
        accent="emerald"
      />

      <MiniStat
        icon={<FaEyeSlash />}
        label="Inactives"
        value={stats.inactive}
        helper="Masquées ou désactivées"
        accent="slate"
      />

      <MiniStat
        icon={<FaStar />}
        label="Mises en avant"
        value={stats.featured}
        helper="Associations favorites"
        accent="amber"
      />
    </div>
  );
}

function MiniStat({ icon, label, value, helper, accent = "indigo" }) {
  const accents = {
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    slate:
      "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300",
  };

  return (
    <div className={`rounded-2xl border px-4 py-3 ${accents[accent]}`}>
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-900/50">
          {icon}
        </div>

        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] opacity-75">
            {label}
          </p>

          <p className="mt-0.5 text-xl font-bold text-slate-950 dark:text-white">
            {Number(value || 0).toLocaleString("fr-FR")}
          </p>

          {helper && (
            <p className="mt-0.5 text-xs text-slate-600 dark:text-slate-300">
              {helper}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}